var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "RewardCardList",
      "extra-items": _vm.isReadOnly ? [{
        text: _vm.form.title
      }] : _vm.isEditing ? [{
        text: _vm.form.title,
        to: 'RewardCardView',
        params: _vm.$route.params.reward_card_id
      }, '編輯集點卡'] : ['新增集點卡']
    }
  })], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.isReadOnly ? "檢視集點卡" : _vm.isEditing ? '編輯集點卡' : '新增集點卡'))]), _c('div', {
    staticClass: "mb-2"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "通路",
      "label-for": "merchant"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": false == _vm.merchantsAreFetched || _vm.isReadOnly
    },
    model: {
      value: _vm.form.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "merchant_id", $$v);
      },
      expression: "form.merchant_id"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.merchant_id.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店"
    }
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.disabled_branch_select
    },
    on: {
      "input": _vm.branchChange
    },
    model: {
      value: _vm.selected_branch,
      callback: function callback($$v) {
        _vm.selected_branch = $$v;
      },
      expression: "selected_branch"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "集點卡名稱"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.title.$error') ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.title.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 主圖 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 不限")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('AppFileUploader', {
          attrs: {
            "placeholder-when-uploaded": "（查看檔案）",
            "placeholder-when-empty": ""
          },
          model: {
            value: _vm.form.config.main_image,
            callback: function callback($$v) {
              _vm.$set(_vm.form.config, "main_image", $$v);
            },
            expression: "form.config.main_image"
          }
        })];
      },
      proxy: true
    }])
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "使用期間"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "language": _vm.zh,
      "format": "yyyy-MM-dd",
      "disabled": _vm.isReadOnly,
      "clear-button": !_vm.isReadOnly,
      "input-class": _vm.deepGet(_vm.v$, 'form.start_at.$error') ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "start_at", $$v);
      },
      expression: "form.start_at"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "language": _vm.zh,
      "format": "yyyy-MM-dd",
      "disabled": _vm.isReadOnly,
      "clear-button": !_vm.isReadOnly,
      "input-class": _vm.deepGet(_vm.v$, 'form.end_at.$error') ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.end_at,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "end_at", $$v);
      },
      expression: "form.end_at"
    }
  })], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.start_at.beforeEndAt.$invalid')
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "卡面點數"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.point_number.$error') ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.point_number,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "point_number", $$v);
      },
      expression: "form.point_number"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.point_number.$error')
    }
  }, [_vm._v(" 此欄位為必填，數值在 1 ~ 10 之間 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "開卡贈送點數"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.give_number.$error') ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.give_number,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "give_number", $$v);
      },
      expression: "form.give_number"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.give_number.$error')
    }
  }, [_vm._v(" 開卡贈送點數需介於 0~卡面點數之間 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "集點累積上限"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.point_collection_limit.$error') ? false : null,
      "readonly": _vm.isReadOnly,
      "placeholder": "不填寫，表示不限制"
    },
    model: {
      value: _vm.form.point_collection_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "point_collection_limit", $$v);
      },
      expression: "form.point_collection_limit"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.point_collection_limit.$error')
    }
  }, [_vm._v(" 集點累積上限須為數字 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "呈現模式"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.showUsedPointOptions,
      "disabled": _vm.isReadOnly,
      "state": _vm.deepGet(_vm.v$, 'form.show_used_point.$error') ? false : null
    },
    model: {
      value: _vm.form.show_used_point,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "show_used_point", $$v);
      },
      expression: "form.show_used_point"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.show_used_point.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "顯示兌換獎項"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.showOrHideOptions,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.show_gift_tab,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "show_gift_tab", $$v);
      },
      expression: "form.config.show_gift_tab"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "顯示兌換紀錄"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.showOrHideOptions,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.show_received_tab,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "show_received_tab", $$v);
      },
      expression: "form.config.show_received_tab"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "顯示點數紀錄"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.showOrHideOptions,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.show_point_log_tab,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "show_point_log_tab", $$v);
      },
      expression: "form.config.show_point_log_tab"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "獎項兌換類型"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.redeemTypeOptions,
      "disabled": _vm.isReadOnly,
      "state": _vm.deepGet(_vm.v$, 'form.config.redeem_type.$error') ? false : null
    },
    model: {
      value: _vm.form.config.redeem_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "redeem_type", $$v);
      },
      expression: "form.config.redeem_type"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.redeem_type.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "獎項兌換條件"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.checkTypeOptions,
      "disabled": _vm.isReadOnly || _vm.form.config.gift_section.branch_list.enable,
      "state": _vm.deepGet(_vm.v$, 'form.config.check_type.$error') ? false : null
    },
    model: {
      value: _vm.form.config.check_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "check_type", $$v);
      },
      expression: "form.config.check_type"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.check_type.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "獎項兌換順序"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.redemptionOrderTypeOptions,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.redemption_order_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "redemption_order_type", $$v);
      },
      expression: "form.config.redemption_order_type"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "查看集點卡權限"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "registered",
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.permissions,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "permissions", $$v);
      },
      expression: "form.config.permissions"
    }
  }, [_vm._v("需註冊")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "集點權限"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "registered",
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.collect_point_permissions,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "collect_point_permissions", $$v);
      },
      expression: "form.config.collect_point_permissions"
    }
  }, [_vm._v("需註冊")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "兌換權限"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "registered",
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.redeem_permissions,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "redeem_permissions", $$v);
      },
      expression: "form.config.redeem_permissions"
    }
  }, [_vm._v("需註冊")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "活動方式"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.eventSettingOptions,
      "disabled": !_vm.canModifyEventSetting || _vm.isReadOnly,
      "state": _vm.deepGet(_vm.v$, 'form.event_setting.$error') ? false : null
    },
    model: {
      value: _vm.form.event_setting,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "event_setting", $$v);
      },
      expression: "form.event_setting"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.event_setting.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _vm.showEventSelection ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "活動代碼"
    }
  }, [_vm.form.event_setting === 'select' ? _c('AppSingleSelect', {
    attrs: {
      "options": _vm.eventOptions,
      "disabled": !_vm.canModifyEventSetting || _vm.isReadOnly
    },
    on: {
      "input": _vm.onEventSelectChange
    },
    model: {
      value: _vm.selectedEvent,
      callback: function callback($$v) {
        _vm.selectedEvent = $$v;
      },
      expression: "selectedEvent"
    }
  }) : _vm._e(), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.event_id.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")]), _vm.form.event_setting === 'manual' ? _c('b-form-input', {
    attrs: {
      "value": _vm.form.event_code,
      "readonly": !_vm.canModifyEventSetting || _vm.isReadOnly,
      "placeholder": "請輸入活動代碼"
    },
    on: {
      "input": _vm.onEventCodeInput
    }
  }) : _vm._e(), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.event_code.$error')
    }
  }, [_vm.deepGet(_vm.v$, 'form.event_code.required.$invalid') ? [_vm._v(" 此欄位為必填 ")] : _vm.deepGet(_vm.v$, 'form.event_code.eventCodeFormat.$invalid') ? [_vm._v(" 僅允許輸入大寫英文、數字、底線(_) ")] : _vm._e()], 2)], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "注意事項"
    }
  }, [_c('TrixEditor', {
    attrs: {
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.memo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "memo", $$v);
      },
      expression: "form.memo"
    }
  })], 1), _vm.hasAdvandePermission ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用分店下拉"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.isReadOnly || _vm.form.config.check_type === 'need_branch_code'
    },
    model: {
      value: _vm.form.config.gift_section.branch_list.enable,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.gift_section.branch_list, "enable", $$v);
      },
      expression: "form.config.gift_section.branch_list.enable"
    }
  })], 1) : _vm._e(), _vm.hasAdvandePermission ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店下拉選單來源"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.gift_section.branch_list.branch_provider,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.gift_section.branch_list, "branch_provider", $$v);
      },
      expression: "form.config.gift_section.branch_list.branch_provider"
    }
  })], 1) : _vm._e(), _vm.hasAdvandePermission ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店下拉選單文字"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.gift_section.branch_list.default_select_text,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.gift_section.branch_list, "default_select_text", $$v);
      },
      expression: "form.config.gift_section.branch_list.default_select_text"
    }
  })], 1) : _vm._e(), _vm.hasAdvandePermission ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否顯示分店代號"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.gift_section.branch_list.show_branch_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.gift_section.branch_list, "show_branch_code", $$v);
      },
      expression: "form.config.gift_section.branch_list.show_branch_code"
    }
  })], 1) : _vm._e(), _vm.hasAdvandePermission ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品是否使用庫存"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.gift_section.enable_product_stock,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.gift_section, "enable_product_stock", $$v);
      },
      expression: "form.config.gift_section.enable_product_stock"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), false == _vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")]) : _vm._e()], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }